export function logBoard(boardArray) {

  console.log(" ")
  console.log(boardArray[0] + " | " + boardArray[1]+" | " + boardArray[2])
  console.log(boardArray[3] + " | " + boardArray[4]+" | " + boardArray[5])
  console.log(boardArray[6] + " | " + boardArray[7]+" | " + boardArray[8])

}
